// Modules
import { gql } from '@apollo/client'

export const ValidateLoginContact = gql`
    query validateLoginContact($contactType: ContactTypes!, $contactValue: String!) {
        validateLoginContact(contactType: $contactType, contactValue: $contactValue) {
            status
        }
    }
`
